<template>
    <div class="home">
        <img ref="bannerHeight" src="@/assets/banner.png" style="width:100%">
        <div class="container flex margin-top-sm" style="overflow: hidden;">
            <div>
                <div class="title-style">
                    <p class="padding-top-xs">{{title}}</p>
                    <p class="border-short"></p>
                </div>
                <ul>
                    <li v-for="(item,index) in routeList" :key="index" @click="onDetail(item,index)"
                        v-show="!item.meta.hidden" :class="activeMenu==item.name?'active-style':''">
                        <span class="li-span"><span class="point" v-show="activeMenu==item.name"></span></span>
                        <span>{{item.meta.title}}</span></li>
                </ul>
            </div>
            <div class="margin-tb-sm margin-left" style="width:77%;">
                <el-tabs>
                    <el-tab-pane :label="activeName"></el-tab-pane>
                </el-tabs>
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>

            </div>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'Home',
        components: {

        },
        data() {
            return {
                title: ''
            }
        },
        computed: {
            routeList() {
                return this.$store.state.routes.filter(e => e.path == this.$route.meta.parent)[0].children
            },
            activeMenu() {
                if (this.$route.query && this.$route.query.name) {
                    return this.$route.query.name
                } else {
                    return this.$route.name
                }
            },
            activeName() {
                if (this.$route.query && this.$route.query.name) {
                    let name = this.routeList.filter(e => e.name == this.$route.query.name)[0].meta.title
                    return name
                } else {
                    return this.$route.meta.title
                }
            }
        },
        mounted() {
            this.title = this.$store.state.routes.filter(e => e.path == this.$route.meta.parent)[0].meta.title
        },
        methods: {
            imgLoad() {

            },
            onDetail(val) {
                let parent = val.meta.parent
                let url = parent + '/' + val.path
                this.$router.push({
                    path: url
                })
            }
        }
    }
</script>
<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.2s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        opacity: 0.4;
    }
</style>
<style scoped>

    .title-style {
        height: 64px;
        color: #ffffff;
        background: #AA0000;
        width: 210px;
        padding-left: 30px;
    }

    .border-short {
        height: 1px;
        background: #ffffff;
        width: 38px;
    }

    li {
        height: 45px;
        cursor: pointer;
        color: #252B3A;
        line-height: 45px;
        padding-left: 25px;
        transition: all 0.5s;
        /* margin-top: 10px; */
    }

    .li-span {
        display: inline-block;
        width: 20px;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 10px;
        width: 220px;
        background: #F6F7F8;
        height: 100%;
        min-height: 240px;
    }

    .active-style {
        background: #FFFFFF;
    }

    .point {
        width: 7px;
        height: 7px;
        background: #AA0000;
        display: inline-block;
        margin-right: 15px;
        vertical-align: middle;
    }
</style>